module.exports = __webpack_public_path__ + "img/020083.c2a654f3.png";